var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SELECT_DATE"},[_c('DatePicker',{attrs:{"value":_vm.valuedata,"format":"yyyy-MM-dd","type":"date","transfer":"","placeholder":"请选择查询时间"},on:{"on-change":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }